module.exports = __webpack_public_path__ + "static/media/casita.36dbd7f4.png";